module.exports = __webpack_public_path__ + "img/text21.7026d065.webp";